module.exports = __webpack_public_path__ + "static/img/case3.6f17b54.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case3.jpg
// module id = okyq
// module chunks = 1